import { FormDialog } from 'components/dialog/form'
import { SearchsDiseaseResult, useEditSearchsDisease } from 'interface/search/disease'
import { useSearchsDiseaseForm, SearchsDiseaseForm } from '../form'

type EditSearchsDiseaseDialogProps = {
  searchId: number
  disease: SearchsDiseaseResult
  onSubmit: (result: SearchsDiseaseResult) => void
  onClose: () => void
}
export const EditSearchsDiseaseDialog = ({
  searchId,
  disease,
  onSubmit,
  onClose
}: EditSearchsDiseaseDialogProps) => {
  const [postState, submit] = useEditSearchsDisease(searchId, disease.searchsDiseaseId, { onEditted: onSubmit })
  const form = useSearchsDiseaseForm({ data: disease, onSubmit: submit })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title={disease.diseaseName ?? 'No name'}
      isLoading={postState.posting}
      error={postState.error}
      body={<SearchsDiseaseForm form={form}/>}
      submitLabel="確定"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
